export const reasonEnum = {
    '-1': '内容涉嫌违规，已被删除',
    '-2': '内容已经被圈主删除',
    '-3': '内容涉嫌违规，已被删除',
    undefined: '内容已经被作者删除',
};
